import { DateTime } from 'luxon';
import type { SigningPageRecipient } from '../types/signing-page-recipient';
import type { Recipient } from '../types/Recipient';
import { DocumentStatus } from '../enums/document-status';

export class DocumentHelper {
  static isExpired(date: string): boolean {
    const expirationDate: DateTime = DateTime.fromISO(date);
    const currentDate: DateTime = DateTime.now();
    return currentDate > expirationDate;
  }

  static isPartiallySignedOrApproved(recipients: Recipient[] | SigningPageRecipient[]): boolean {
    if (!recipients.length) {
      return;
    }
    return recipients.some(
      recipient =>
        recipient.status === DocumentStatus.Signed || recipient.status === DocumentStatus.Approved
    );
  }
}
